import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, SparklesIcon, CheckCircle2Icon } from 'lucide-react';
export function WinxBonusSection() {
  return <section className="py-12 md:py-16 px-4 bg-gradient-to-b from-[#FFFAF7] to-[#F5F0FF] overflow-hidden relative" data-id="element-204" data-mp="1jom1sb47n9d3">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-205" data-mp="1aoyxnhk3jpgc">
        <div className="absolute top-10 left-10 text-[#FFD166]/20" data-id="element-206" data-mp="15rfj0gjhlanv">
          <SparklesIcon className="w-16 h-16" data-id="element-207" data-mp="10zfcg58wvjib" />
        </div>
        <div className="absolute bottom-10 right-10 text-[#9B8FE8]/20" data-id="element-208" data-mp="10xujul65qan3">
          <SparklesIcon className="w-24 h-24" data-id="element-209" data-mp="w1duxor4vs8y" />
        </div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-210" data-mp="r2j3jyf3ovd8">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-3xl shadow-2xl border-4 border-[#FFD166] p-6 md:p-10 flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-211" data-mp="qzwufucka7sw">
          {/* Image Column */}
          <div className="w-full md:w-2/5 relative" data-id="element-212" data-mp="1jpjv6hb6jalz">
            <div className="absolute -top-4 -left-4 md:-top-6 md:-left-6 bg-[#FF6B8A] text-white font-black px-4 py-2 rounded-full shadow-lg transform -rotate-6 text-sm md:text-base z-20 flex items-center gap-2 border-2 border-white" data-id="element-213" data-mp="15x3wfspb9yqv">
              <GiftIcon className="w-4 h-4" data-id="element-214" data-mp="1xo9p5o2pcu64" />
              NUEVO REGALO
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/5jRxwFUsKaorENW2ugoQow/winx_club.webp" alt="Winx Club Coloring Book" className="w-full rounded-xl shadow-lg object-cover relative z-10" data-id="element-215" data-mp="22ljnjt82kg63" />
            {/* Glow effect behind image */}
            <div className="absolute inset-0 bg-[#FFD166] blur-2xl opacity-30 -z-0 rounded-full scale-110" data-id="element-216" data-mp="d73plob92bld" />
          </div>

          {/* Text Column */}
          <div className="w-full md:w-3/5 flex flex-col space-y-5" data-id="element-217" data-mp="2jw5m26azoqxh">
            <div data-id="element-218" data-mp="2jvdvj9w91je2">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-[#2D2D3F] leading-tight mb-2" data-id="element-219" data-mp="2jy02b7bbfuv8">
                ¡Ahora el Mega Pack incluye un nuevo libro de REGALO!
              </h2>
              <p className="text-lg md:text-xl text-[#6B7280] font-medium" data-id="element-220" data-mp="2a3zngdq8fb9b">
                Llevate también el nuevo libro de <span className="text-[#FF6B8A] font-bold" data-id="element-221" data-mp="215nvo8dmq7fa">Winx Club</span> con 50 diseños para colorear.
              </p>
            </div>

            <div className="bg-[#FFF5F7] border border-[#FFD1D9] rounded-2xl p-4 md:p-5" data-id="element-222" data-mp="1w5t8aet2bzyz">
              <h3 className="font-bold text-[#FF6B8A] flex items-center gap-2 mb-3 text-sm md:text-base uppercase tracking-wide" data-id="element-223" data-mp="1r8jb2czfmk0l">
                <GiftIcon className="w-5 h-5" data-id="element-224" data-mp="1n7pktcyiot4j" />
                Exclusivo con el Mega Pack
              </h3>
              <ul className="space-y-2" data-id="element-225" data-mp="3ljet05wibbg1">
                {['Winx Club Coloring Book', '+50 diseños para colorear', 'Formato digital', 'Descarga inmediata'].map((item, idx) => <li key={idx} className="flex items-center text-[#2D2D3F] font-medium text-sm md:text-base" data-id="element-226" data-mp="189y91dhrkfnl" data-mpi={idx}>
                    <CheckCircle2Icon className="w-4 h-4 text-[#FFD166] mr-2 shrink-0" data-id="element-227" data-mp="1d2hka3szayp8" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <p className="text-sm md:text-base text-[#2D2D3F] font-semibold bg-[#FFD166]/20 inline-block px-4 py-3 rounded-xl border border-[#FFD166]/30" data-id="element-228" data-mp="kev8w9dieprt">
              Comprando el Mega Pack recibís todos los libros de Disney + este nuevo libro de Winx Club completamente <span className="font-black text-[#FF6B8A]" data-id="element-229" data-mp="ydl6dq48qrgp">GRATIS</span>.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}